export default __webpack_public_path__ + "static/media/tootipInfoIcon.b0f150d0.svg";